@if (initialized && dto) {
    @if (uiMode == 'side') {

        <bm-bank-transaction-domain-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-bank-transaction-domain-full>
    } @else {

        <bm-bank-transaction-domain-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-bank-transaction-domain-side>
    }
}
